import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {ThinCaretDownIcon, ThinTimeIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";

export interface entranceLogSingleInterface {
    id: number,
    isEntrance: 0 | 1,
    createdAt: string,
    isAuto: 0 | 1,
}

export const StudentsAttendScreen = () => {
    const [attendList, setAttendList] = useState<entranceLogSingleInterface[]>([]);
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const fetchList = () => {
        setFilters({shown: ''});
        const t = {...time};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        ShowProgressLoading();
        //window.scrollTo({top: 0, behavior: 'smooth'});
        PostJSON(
            Apis.server + "/core/parents/attend/list-entrances",
            {
                f: fromString,
                t: toString,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: entranceLogSingleInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setAttendList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "حضورغیاب | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'حضوروغیاب', url: '/students/attend'},
            ]}/>
            <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                <div className="screen-card">
                    <div className="screen-card-header">
                        <b>گزارش تردد</b>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        }}>
                            {/*{*/}
                            {/*    attendList.length > 1 ?*/}
                            {/*        <button onClick={() => {*/}
                            {/*            window.open(`/admins/attend/print/${time.from!.year}-${time.from!.month}-${time.from!.day}/${time.to!.year}-${time.to!.month}-${time.to!.day}/${studentId}`);*/}
                            {/*        }}>*/}
                            {/*            <ThinPrintIcon/>*/}
                            {/*            <span>پرینت</span>*/}
                            {/*        </button> : null*/}
                            {/*}*/}
                            <div className="filter-buttons">
                                <ClickOutsideDetector
                                    onClickOutside={() => {
                                        setFilters(v => {
                                            let x = {...v};
                                            x.shown = '';
                                            return x;
                                        });
                                    }}
                                    className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                    <button onClick={(e) => {
                                        e.stopPropagation();
                                        setFilters(v => {
                                            let x = {...v};
                                            x.shown = x.shown === 'time' ? '' : 'time';
                                            return x;
                                        });
                                    }}>
                                        <ThinTimeIcon/>
                                        <span>زمان</span>
                                        <ThinCaretDownIcon/>
                                    </button>
                                    {
                                        filters.shown === 'time' ?
                                            <div>
                                                <label className="f-roboto">لطفا
                                                    یک بازه زمانی را انتخاب
                                                    کنید:</label>
                                                <Calendar
                                                    value={time}
                                                    onChange={e => setTime(e)}
                                                    shouldHighlightWeekends
                                                    colorPrimary='#0a53be'
                                                    locale={'fa'}
                                                />
                                                <div className="text-end">
                                                    <button
                                                        className="filter-button-cta"
                                                        onClick={fetchList}>
                                                        <span>اعمال تغییرات</span>
                                                    </button>
                                                </div>
                                            </div> :
                                            null
                                    }
                                </ClickOutsideDetector>
                            </div>
                        </div>
                    </div>
                    {
                        attendList.length === 0 ?
                            <div className="staff--not-found">
                                <em style={{backgroundImage: 'url(/svg/entrance.svg)'}}/>
                                <b>گزارشی یافت نشد</b>
                                <p>در بازه زمانی انتخاب شده، گزارشی یافت
                                    نشد.</p>
                            </div> :
                            null
                    }
                    {
                        attendList.length > 0 ?
                            <table
                                className="table open-table table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>نوع</th>
                                    <th>تاریخ</th>
                                    <th>زمان</th>
                                    <th>ثبت‌کننده</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    attendList.map((r, i) =>
                                        <tr key={"Jd932uf8" + i}>
                                            <td>{StringDigitsConvertToPersian((i + 1).toString())}</td>
                                            <td>{r.isEntrance ? 'ورود' : 'خروج'}</td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(r.createdAt).replaceAll('-', '/'))}</td>
                                            <td>{StringDigitsConvertToPersian(r.createdAt.split(' ')[1])}</td>
                                            <td>{r.isAuto === 0 ? 'دستگاه' : 'خروج خودکار'}</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table> : null
                    }
                </div>
            </div>
        </>
    );
};